import { IDetailsFormData } from '../../../../shared/account/details/types/IDetailsFormData';
import { getAccountShortcuts } from '../helpers/getAccountShortcuts';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

export type FinalSubmitHandler = (
	data: IDetailsFormData,
) => void | Promise<void>;

export function useAccountShortcuts() {
	const { t } = useTranslation();
	const royaltyProgramUrl = useUrlForPageId(PassengersPageId.RoyaltyProgram);
	const accountDetailsUrl = useUrlForPageId(PassengersPageId.AccountDetails);
	const myVehiclesUrl = useUrlForPageId(PassengersPageId.Vehicles);
	const changePasswordUrl = useUrlForPageId(PassengersPageId.ChangePassword);

	const shortcuts = getAccountShortcuts(t, {
		royaltyProgramUrl,
		accountDetailsUrl,
		myVehiclesUrl,
		changePasswordUrl,
	});

	return { shortcuts };
}
